// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__33hUp","showH1":"banner_showH1__1MV_n","back_photo":"banner_back_photo__2UXtL"};